import React from 'react'

const Vehicle = () => {
    return (
        <div>
            Coming Soon
        </div>
    );
};

export default Vehicle;